export default __webpack_public_path__ + "static/media/q_wdt_c_0.8ec791b1.mp3";